import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <>
      <Navbar />
      <div className="min-h-[80vh] flex items-center justify-center bg-gray-50 py-12 px-4 overflow-hidden relative">
        {/* Background decorative elements */}
        <div className="absolute top-20 left-10 w-64 h-64 bg-[#1A2B4D]/5 rounded-full animate-pulse opacity-70"></div>
        <div
          className="absolute bottom-20 right-10 w-80 h-80 bg-gold/5 rounded-full animate-pulse opacity-70"
          style={{ animationDuration: "3s" }}
        ></div>
        <div
          className="absolute top-1/3 right-1/4 w-20 h-20 bg-[#1A2B4D]/10 rounded-full animate-ping"
          style={{ animationDuration: "4s" }}
        ></div>

        <div className="text-center max-w-md relative z-10">
          <div className="relative mb-12">
            <h1
              className="text-[150px] font-bold text-navy mb-4 animate-fade-in opacity-0 relative z-10"
              style={{
                animationDelay: "0.1s",
                textShadow: "0 10px 20px rgba(0,0,0,0.1)",
              }}
            >
              404
            </h1>
            <div
              className="w-full h-10 bg-gold/30 absolute bottom-10 left-0 right-0 transform skew-x-12 -z-10 animate-fade-in opacity-0"
              style={{ animationDelay: "0.4s" }}
            ></div>
          </div>

          <div className="space-y-8">
            <p
              className="text-2xl text-navy/70 mb-8 animate-slide-in-up opacity-0"
              style={{ animationDelay: "0.3s" }}
            >
              Oops! The page you're looking for can't be found.
            </p>

            <div
              className="animate-fade-in opacity-0 flex flex-col items-center"
              style={{ animationDelay: "0.5s" }}
            >
              <div className="w-32 h-[1px] bg-navy/20 mb-8"></div>
              <Button
                asChild
                className="bg-navy hover:bg-navy-light transition-all duration-300 hover:scale-105 hover:shadow-lg group"
              >
                <Link to="/" className="inline-flex items-center">
                  <ArrowLeft className="mr-2 h-4 w-4 group-hover:-translate-x-1 transition-transform" />
                  <span>Return to Home</span>
                </Link>
              </Button>
            </div>
          </div>

          <div
            className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-24 w-[300px] h-[300px] rounded-full bg-gold/5 -z-10 animate-pulse"
            style={{ animationDuration: "6s" }}
          ></div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NotFound;
